import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "../../utils/hooks";
import CompareResponses from "../Responses/CompareResponses";

const RegistryCompareResponsesWrapper = () => {
  const { participantId, formId } = useParams();
  const formName = useQuery().get("formName");

  return (
    <CompareResponses
      participantId={participantId || ""}
      formId={formId || ""}
      formName={formName || ""}
      type="registry"
    />
  );
};

export default RegistryCompareResponsesWrapper;
